import { render, staticRenderFns } from "./CategoryFeaturedCard.vue?vue&type=template&id=0f8e81ea&scoped=true"
import script from "./CategoryFeaturedCard.vue?vue&type=script&lang=ts"
export * from "./CategoryFeaturedCard.vue?vue&type=script&lang=ts"
import style0 from "./CategoryFeaturedCard.vue?vue&type=style&index=0&id=0f8e81ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8e81ea",
  null
  
)

export default component.exports